import React, { useState } from 'react';
import clsx from 'clsx';

import styles from './InfoPopup.module.css';

export const InfoPopup = ({ onClose }: { onClose: () => void }) => {
  const [shouldClose, setShouldClose] = useState(false);

  const onSubmit = () => {
    setShouldClose(true);
    setTimeout(() => {
      onClose();
    }, 200);
  };

  return (
    <div
      className={clsx(!shouldClose ? 'visible' : 'opacity-0', styles.container)}
    >
      <div className={styles.popupBox}>
        <div className={styles.contentBox}>
          <div className={styles.popup}>
            <p className={styles.text}>
              Используя сайт, вы предоставляете согласие на обработку ваших
              персональных данных с помощью сервисов веб-аналитики
            </p>
            <div className="">
              <button
                type="button"
                className={styles.button}
                onClick={onSubmit}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
